import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { STEP_LABELS, AGREEMENT_LABELS } from "./orderOptions";

export const StepNav = ({ onBack, onNext, nextDisabled }) => {
  const { t } = useLanguage();
  return <div className="mt-8 flex flex-wrap justify-between gap-3">
    {onBack && <button data-testid="order-back-button" onClick={onBack} className="btn-ghost"><ArrowLeft size={16} />{t("Back")}</button>}
    <button data-testid="order-next-button" disabled={nextDisabled} onClick={onNext} className="btn-primary ml-auto">{t("Continue")}<ArrowRight size={16} /></button>
  </div>;
};

const stepColor = (index, step) => {
  if (index < step) return "border-[#10B981] bg-[#10B981]/10 text-[#10B981]";
  if (index === step) return "border-[#E5A93C] bg-[#E5A93C]/10 text-[#FFC857]";
  return "border-[#282C3D] text-slate-500";
};
export const OrderStepper = ({ step, isAgreement }) => {
  const { t } = useLanguage();
  const labels = isAgreement ? AGREEMENT_LABELS : STEP_LABELS;
  return <div data-testid="order-stepper" className="mt-10 flex flex-wrap items-center gap-x-3 gap-y-4 pb-2">
    {labels.map((label, index) => <div key={label} className="flex shrink-0 items-center gap-2">
      <span className={`flex h-7 w-7 items-center justify-center rounded-full border font-mono text-[11px] ${stepColor(index, step)}`}>{index + 1}</span>
      <span data-testid={`order-step-label-${index}`} aria-current={index === step ? "step" : undefined} className={`text-xs ${index === step ? "text-slate-100" : "text-slate-500"}`}>{t(label)}</span>
      {index < labels.length - 1 && <span className="h-px w-3 bg-[#282C3D]" />}
    </div>)}
  </div>;
};

export const OrderSelect = ({ id, testId, label, value, onChange, options, placeholder, disabled }) => {
  const { t } = useLanguage();
  return <div>
    <label className="studio-label" htmlFor={id}>{t(label)}</label>
    <select id={id} data-testid={testId} className="studio-input" value={value} onChange={onChange} disabled={disabled}>
      {placeholder && <option value="">{t(placeholder)}</option>}
      {options.map(option => <option key={option.value} value={option.value}>{t(option.label)}</option>)}
    </select>
  </div>;
};
export const optionsFrom = values => values.map(value => ({ value, label: value }));